let demoMode = false

export function enableDemoMode() {
  demoMode = true
}

export function disableDemoMode() {
  demoMode = false
}

export function isDemoMode() {
  return demoMode
}